import { isValid, parse, parseISO } from 'date-fns';

import { getLocalDateTime } from './date';

export const trimDateString = (date: string) => date.replace(/\s+/g, ' ').trim();

/**
 * Check if a string is in ISO 8601 format.
 */
export const isIsoString = (date: string): boolean => {
  // Matches:
  // 1. '2025-01-21T12:52:08'
  // 2. '2025-01-21T12:52:08.000'
  // 3. '2025-01-21T12:52:08Z'
  // 4. '2025-01-21T12:52:08.000Z'
  // 5. '2025-01-21T12:52:08+01:00'
  // 6. '2025-01-21T12:52:08-05:00'

  const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{3})?(?:Z|([+-])(\d{2}):(\d{2}))?$/;

  return isoRegex.test(date);
};

/**
 * Converts a given UTC date string in specific format to an ISO string in UTC.
 *
 * @param {string} date - The input date string in UTC.
 * @param {string} format - The format of the input date string (e.g., 'MM/dd/yyyy h:mm:ss a').
 * @returns {string} - The normalized date as an ISO string in UTC (e.g., '2024-08-20T09:56:59.287Z').
 */
export const normalizeUTC = (date: string, format: string): string => {
  if (!date) {
    return '';
  }
  const standardizedDate = trimDateString(date); // handle case with redundant spaces
  const isISOdate = isIsoString(standardizedDate);

  const parsedDate = isISOdate ? parseISO(standardizedDate) : parse(standardizedDate, format, getLocalDateTime());

  if (!isValid(parsedDate)) {
    return '';
  }
  parsedDate.setMinutes(parsedDate.getMinutes() - parsedDate.getTimezoneOffset());

  return parsedDate.toISOString();
};
